import { useEffect } from 'react';

import useLandingRedirect from 'hooks/useLandingRedirect';

const ALLOWED_PATHS = [
  '/thank-you',
  '/report',
  '/report/bushfire',
  '/report/cyclone',
  '/report/flood',
  '/report/storm',
];

/**
 * Browser back/forward out of the experience sends the user to /landing.
 * This used to be a `window.location.replace`, which tore down the WebGL
 * canvases in the root layout; it now navigates through the client router
 * so the 3D scene stays mounted.
 */
const RedirectOnPopstate = () => {
  const redirectToLanding = useLandingRedirect();

  useEffect(() => {
    const handlePopState = () => {
      if (ALLOWED_PATHS.includes(window.location.pathname)) return;

      redirectToLanding();
    };

    window.addEventListener('popstate', handlePopState);

    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, [redirectToLanding]);

  return null;
};

export default RedirectOnPopstate;
